<template>
    <v-app :dark="false">
        <v-content>
            <v-container class="fill-height" fluid :style="bgfondo">
                <v-row dense align="center" justify="center">
                    <v-col cols="12" sm="7" md="5">
                        <v-card :class="$root.isTouch ? 'elevation-12 ml-2' : 'elevation-12'" max-height="350" min-height="300">
                            <div class="mt-1 text-center" style="background-color:#ff4132">
                                <img src="@/assets/img/logo-contigo-seguros-white.png" alt="" width="40%">
                            </div>
                            <v-card-text>
                                <v-form ref="form">
                                    <v-text-field v-model="obForm.userName" filled shaped color="primary" dense
                                        label="Login" name="login" prepend-icon="person" type="text"
                                        :rules="usuarioRule" :disabled="disabled"/>

                                    <v-text-field v-model="obForm.userPass" filled shaped color="primary" dense
                                        label="Password" name="password" prepend-icon="lock" type="password"
                                        :rules="claveRule" @keyup.enter.native="login" :disabled="disabled"/>
                                </v-form>
                            </v-card-text>
                            <v-card-actions style="background-color:#ff4132">
                                <v-btn block class="mt-1 mb-1" rounded outlined color="accent" @click="login" :disabled="disabled">
                                    <span style="color:#fff">Iniciar Sesión</span>
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-col>
                </v-row>
                <v-snackbar v-model="obAlert.open" :timeout="obAlert.timeout" right dense>
                    {{ obAlert.text }}
                    <v-btn color="blue" text @click="obAlert.open = false"> Close </v-btn>
                </v-snackbar>
            </v-container>
        </v-content>
    </v-app>
</template>

<script>
    export default {
        props: {
            source: String,
        },
        data() {
            return {
                bgfondo: "background-image: url('" + require('@/assets/img/bg-screen.png') +
                    "'); background-size: cover",
                obForm: {
                    userName: null,
                    userPass: null
                },
                loading: false,
                obAlert: {
                    open: false,
                    timeout: 2000,
                    text: ''
                },
                disabled:false,
                usuarioRule: [v => !!v || 'El campo usuario es requerido'],
                claveRule: [v => !!v || 'El campo usuario es requerido'],
            }
        },
        created(){
            var urlParams = new URLSearchParams(window.location.search);
            if(urlParams.has('token')){
                this.disabled = true;
                this.loginToken(urlParams.get('token'));
            }
        },
        methods: {
            loginToken(token) {
                try {
                    this.loading = true;
                    axios.post(`${BASE_URI}seguridad/login-token`, {token:token})
                        .then((r) => {
                            if (_.size(_.get(r, ['data', 'data'], [])) == 0) throw 'Credenciales Invalidas.';
                            this.loading = false;
                            localStorage.setItem('informacion', JSON.stringify(r.data.data.informacionUsuario));
                            localStorage.setItem('token', _.replace(r.data.data.token.token, '"', ''));
                            var menu = this.formatMenu(r.data.data.menu);
                            localStorage.setItem('menu', JSON.stringify(menu));
                            axios.defaults.headers.common['Authorization'] = localStorage.getItem('token');
                            this.$root.accessPla = true;
                            this.$router.push(`/main`);
                        })
                        .catch((e) => {
                            this.loading = false;
                            mensajesAlerta(e, 'E');
                        });

                } catch (error) {
                    mensajesAlerta(error, 'E');
                }
            },
            login() {
                try {
                    if (!this.$refs.form.validate()) throw 'Debe corregir la información.';
                    this.loading = true;

                    axios.post(`${BASE_URI}seguridad/login`, this.obForm)
                        .then((r) => {
                            if (_.size(_.get(r, ['data', 'data'], [])) == 0) throw 'Credenciales Invalidas.';
                            this.loading = false;
                            localStorage.setItem('informacion', JSON.stringify(r.data.data.informacionUsuario));
                            localStorage.setItem('token', _.replace(r.data.data.token.token, '"', ''));
                            var menu = this.formatMenu(r.data.data.menu);
                            localStorage.setItem('menu', JSON.stringify(menu));
                            axios.defaults.headers.common['Authorization'] = localStorage.getItem('token');
                            this.$router.push(`/main`);
                        })
                        .catch((e) => {
                            this.loading = false;
                            mensajesAlerta(e, 'E');
                        });

                } catch (error) {
                    mensajesAlerta(error, 'E');
                }
            },
            formatMenu(listMenu){
                var menu = [];
                _.forEach(listMenu,(v,k) =>{
                    var ob = [];
                    _.forEach(v,(items,i) =>{
                        _.forEach(items,(opcion,d)=>{
                            ob.push({
                                'title': opcion.opcion,
                                'icon': opcion.icono,
                                'path': opcion.vista
                            });
                        });

                        menu.push({
                            action: i,
                            title: _.get(items,['0','modulo'],'N/A'),
                            items: ob
                        });
                    });
                });
                return menu;
            }
        }
    }
</script>